module.exports = __webpack_public_path__ + "static/Global_Headquarters-d3a9715952f5bf4fac67071efc94ef7c.png";